import React from 'react';
import UDFormLabel from 'ud-form/components/label';

const SkeletonBlock = ({ height, className }: { height: number; className?: string }) => (
  <div className={className}>
    <div style={{ height, width: '100%' }} className="skeleton-block" />
  </div>
);

const NotificationFormSkeleton: React.FC = () => (
  <div className="flex w-1/2 flex-col gap-4">
    <div>
      <UDFormLabel className="mb-2">Тип уведомления</UDFormLabel>
      <SkeletonBlock height={38} />
    </div>
    <div>
      <UDFormLabel className="mb-2">Заголовок</UDFormLabel>
      <SkeletonBlock height={38} />
    </div>
    <div>
      <UDFormLabel className="mb-2">Текст</UDFormLabel>
      <SkeletonBlock height={120} />
    </div>
    <div className="mt-4 flex justify-start gap-3">
      <SkeletonBlock height={38} className="w-full" />
      <SkeletonBlock height={38} className="w-full" />
    </div>
  </div>
);

export default NotificationFormSkeleton;
